module.exports = __webpack_public_path__ + "img/289.28e19536.jpg";